const errorMappings = [
  {
    match:
      /The (recipient|sender)_phone_number field must be a valid phone number in E\.164 format \(e\.g\., \+123456789\)/,
    code: 'salesOrder.validation.invalidPhoneNumber',
  },
]

export default errorMappings
